import { useRootStore } from '../stores/root';
import { initSupportUser, clearSupportUser } from './supportUser';
import router from '../router';
import { retrieveTokensAndSetCookies } from './token_extraction';
import { isArray, isRecord } from './type_guards';
import {
  setV3StopAssumeUserCookie,
  unsetAssumedUserOrgCookies,
  unsetV3StopAssumeUserCookie,
} from './v2AuthLoader';

export async function assumeDifferentUser(orgId: string, userId: string) {
  const store = useRootStore();

  const user: Record<string, unknown> = isRecord(store.user) ? store.user : {};
  const orgs = isArray(user.organizations) ? user.organizations : [];

  await clearSupportUser(store.userId, orgs);
  await initSupportUser(store.userId, orgId, orgs);

  store.patches = null;
  store.hierarchyByUser = null;
  // store.businessUnits = null;
  localStorage.removeItem('cimtToken');
  localStorage.removeItem('ebosLoginDone');
  localStorage.setItem('assumedUserID', userId);
  localStorage.setItem('assumedOrgId', orgId);
  // if we are not already assuming a user, set preAssumedUser to the logged in user
  if (!store.assumingUser) {
    const preAssumedUser = {
      name: user.userName,
      userId: user.userId,
      orgId: isRecord(user.organization) ? user.organization.orgId : undefined,
      qsrAdmin: user.qsrAdmin,
    };
    localStorage.setItem('preAssumedUser', JSON.stringify(preAssumedUser));
  }

  store.assumingUser = true;

  await store.reload();

  await retrieveTokensAndSetCookies();
  await router.push('/home-dashboard');

  unsetV3StopAssumeUserCookie();

  window.sendMessageToApp?.('assumeUser', {
    orgId,
    userId,
  });

  store.remountApp();
  const isCommsHub = store.enterpriseClient === 'CommsHub';
  const redirectPath = isCommsHub ? '/commshub/home' : '/home-dashboard';

  await router.push({ path: redirectPath, force: true });
}

export function stopAssumingUser(
  options: { setCookie: boolean } = { setCookie: true },
) {
  const store = useRootStore();

  localStorage.removeItem('assumedUserID');
  localStorage.removeItem('assumedOrgId');
  localStorage.removeItem('multiOrgUserSelectedOrgId');
  localStorage.removeItem('user');
  localStorage.removeItem('preAssumedUser');
  localStorage.removeItem('cimtToken');
  localStorage.removeItem('ebosLoginDone');
  unsetAssumedUserOrgCookies();
  store.assumingUser = false;
  store.user = null;
  store.hydrate();

  window.sendMessageToApp?.('stopAssumeUser');

  if (options.setCookie) {
    setV3StopAssumeUserCookie();
  }
}
